module.exports = __webpack_public_path__ + "img/mp-icon.8a23be49.png";